<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       :viewBox="viewBox"
       :fill="fill"
       :aria-labelledby="iconName"
       role="presentation"
  >
    <title :id="iconName" lang="en">{{iconName}} icon</title>
    <g>
      <slot />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    viewBox: {
      type: String,
      default: '0 0 16 16'
    },
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 16
    },
    fill: {
      type: String,
      default: 'none'
    },
    iconName: {
      type: String,
      default: 'box'
    },
  },
//   todo для растяжения иконки до ширины родительского контейнера, использовать width="100%" height="100%"
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
}
</style>